module.exports = __webpack_public_path__ + "88a9f06de837f38398ffd422952772b8.webp";